import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { qrRedirectQueryKeys } from "./queryKeys";
import { IQRRedirect } from "./../../models/qrRedirect/QRRedirect";
import useUserContext from "../../contexts/UserContext";

export function useQRRedirects() {
    const { user: { agency } } = useUserContext();
  const { get } = useApiHelper();

  const qrRedirects = useQuery({
    queryKey: qrRedirectQueryKeys.all(),
    queryFn: () =>
      get(`/redirect/${agency.id}/manage`) as unknown as IDefaultResponseWithData<
        IQRRedirect[]
      >,
    refetchOnWindowFocus: false,
  });

  return {
    qrRedirects,
  };
}
